import React from 'react';
import { Box, Container, Typography, Link, Stack, IconButton, useTheme, useMediaQuery } from '@mui/material';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TwitterIcon from '@mui/icons-material/Twitter';
import EmailIcon from '@mui/icons-material/Email';

const neonGreen = '#39FF14';
const darkBg = '#1a1a1a';

export const Footer = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      component="footer"
      sx={{
        py: { xs: 3, sm: 2 },
        px: { xs: 2, sm: 2 },
        mt: 'auto',
        backgroundColor: darkBg,
      }}
    >
      <Container maxWidth="lg">
        <Stack
          spacing={{ xs: 2, sm: 0 }}
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'space-between',
            alignItems: { xs: 'center', sm: 'center' },
          }}
        >
          <Stack 
            direction={{ xs: 'column', sm: 'row' }} 
            spacing={{ xs: 1, sm: 2 }} 
            alignItems="center"
          >
            <Typography 
              variant="body2" 
              color="white"
              sx={{ textAlign: { xs: 'center', sm: 'left' } }}
            >
              {new Date().getFullYear()} Strategiz
            </Typography>
            <Box 
              component="span" 
              sx={{ 
                color: 'white', 
                opacity: 0.5,
                display: { xs: 'none', sm: 'block' }
              }}
            >
              •
            </Box>
            <Link 
              href="mailto:support@strategiz.io" 
              sx={{ 
                color: 'white', 
                fontSize: '0.875rem',
                display: 'flex',
                alignItems: 'center',
                gap: 0.5,
                '&:hover': { color: neonGreen },
                textAlign: { xs: 'center', sm: 'left' }
              }}
            >
              <EmailIcon fontSize="small" />
              {!isMobile && 'support@strategiz.io'}
            </Link>
          </Stack>

          <Stack 
            direction={{ xs: 'column', sm: 'row' }} 
            spacing={{ xs: 2, sm: 2 }} 
            alignItems="center"
          >
            <Stack 
              direction="row" 
              spacing={1}
              sx={{
                order: { xs: 2, sm: 1 }
              }}
            >
              <Link 
                href="/privacy" 
                sx={{ 
                  color: 'white', 
                  fontSize: '0.875rem', 
                  '&:hover': { color: neonGreen } 
                }}
              >
                Privacy
              </Link>
              <Box component="span" sx={{ color: 'white', opacity: 0.5 }}>•</Box>
              <Link 
                href="/terms" 
                sx={{ 
                  color: 'white', 
                  fontSize: '0.875rem', 
                  '&:hover': { color: neonGreen } 
                }}
              >
                Terms
              </Link>
            </Stack>
            <Stack 
              direction="row" 
              spacing={1}
              sx={{
                order: { xs: 1, sm: 2 }
              }}
            >
              <IconButton
                href="https://github.com/strategiz-io/strategiz"
                target="_blank"
                size="small"
                sx={{
                  color: 'white',
                  padding: 0.5,
                  '&:hover': { color: neonGreen }
                }}
              >
                <GitHubIcon fontSize="small" />
              </IconButton>
              <IconButton
                href="https://linkedin.com/company/strategiz-io"
                target="_blank"
                size="small"
                sx={{
                  color: 'white',
                  padding: 0.5,
                  '&:hover': { color: neonGreen }
                }}
              >
                <LinkedInIcon fontSize="small" />
              </IconButton>
              <IconButton
                href="https://twitter.com/stratigiz"
                target="_blank"
                size="small"
                sx={{
                  color: 'white',
                  padding: 0.5,
                  '&:hover': { color: neonGreen }
                }}
              >
                <TwitterIcon fontSize="small" />
              </IconButton>
            </Stack>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
};
